import { rest } from "../services";

export class MetadataLoader {
    
    constructor() {
        this.metadata = {};
    }    
    
	load = async (entity, filter) => {
        if (!filter) {
            filter = {};
            filter[entity] = {};
        }
       	return rest.search(entity, filter)
            .then(response => {
				this.metadata[entity] = {};
                response.forEach(element => {
                    this.metadata[entity][element['id']] = element;
                });
                if(this.postLoad)
                    this.postLoad(response);
        })
    }
    
    get = (entity) => {
    	return this.metadata[entity];
    }
	
	reload = (entity) => {
        if (this.customReload)
            this.customReload();
        else
            this.load(entity);
    }
	
	getDefaultDto2ViewTransformer = (entity) => {
        let metadata = this.metadata[entity]
        let filteredData = {};
        Object.keys(metadata).forEach(element => {
            filteredData[element] = metadata[element]['name'];
        });
        return filteredData;
    }

}

export const metadataLoader = new MetadataLoader();

export function getServiceUri() {
    return '/api/';
}